export default __webpack_public_path__ + "static/media/agenda-bottom-bg.bf17f685.png";